import { render, staticRenderFns } from "./SoftwareComponentTypeList.vue?vue&type=template&id=2b3d98fe&"
import script from "./SoftwareComponentTypeList.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentTypeList.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentTypeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports